import React, { Component } from "react";
import styles from "./geocoderSearch.module.scss";
import { withGeocoder } from "../../shared/containers/containerGeocoder";
import Icon from "../../shared/items/static/icon";
import { states } from "../../reducers/queriesStates";
import Preloader from "../../shared/items/static/preloader";
import InputMask from "react-input-mask";
/*Не работает на Windows 7*/
//import SpeechToText from "../SpeechToText/SpeechToText";

let geocoderSearchTimeIutId = null;

class GeocoderSearch extends Component {
  handleChangeStore(name, value) {
    const { onGeocoderSearch } = this.props;

    clearTimeout(geocoderSearchTimeIutId);

    geocoderSearchTimeIutId = setTimeout(() => {
      onGeocoderSearch({ query: value });
    }, 600);
  }

  onSelectResult(item) {
    const { onSelectGeocoderSearch, onHadleSelectSearchResult = () => {}, onSetGeocoderSearchData } = this.props;
    onSetGeocoderSearchData(item.displayName);
    onSelectGeocoderSearch(item);
    onHadleSelectSearchResult(item);
  }

  handleChange(event) {
    const { onSetGeocoderSearchData, dataSearch } = this.props;

    const value = event.target.value;

    if (value !== dataSearch) {
      onSetGeocoderSearchData(value);
      this.handleChangeStore("", value);
    }
  }

  componentWillUnmount() {
    const { onClearGeocoderSearch } = this.props;
    onClearGeocoderSearch();
  }

  render() {
    const { width = 850, geocoderSearchResult, selectedGeocoderSearch, searchDataState, dataSearch } = this.props;

    return (
      <div className={styles.geocoderSearchContainer}>
        <div className={styles.geocoderSearchInputContauiner} style={{ width: `${width}pt` }}>
      {/*     <div>
            <SpeechToText />
          </div> */}
          <div className={styles.inputStyle}>
            <InputMask
              id={"geocoderSearchId"}
              style={{ width: `${100}%` }}
              type={"text"}
              placeholder={"Поиск по адресу"}
              onChange={this.handleChange.bind(this)}
              value={dataSearch}
            />
          </div>

          {searchDataState === states.REQUEST ? (
            <div className={styles.container_searchBtn}>
              <Preloader size={20} />
            </div>
          ) : (
            <div className={styles.container_searchBtn}>
              <Icon name="search" />
            </div>
          )}
        </div>

        {selectedGeocoderSearch === null && geocoderSearchResult.length > 0 ? (
          <div className={styles.geocoderSerchResultsContainer}>
            {geocoderSearchResult.map((x, index) => {
              return (
                <div
                  className={styles.geocoderSerchResultItem}
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onSelectResult(x);
                  }}
                >
                  {x.displayName}
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
}

export default withGeocoder(React.memo(GeocoderSearch));
